import { useState, useEffect } from 'react';

/**
 * Copied from
 * https://git.hubteam.com/HubSpot/CRM/blob/ca4ca16fb2def5b9f745d1eeab389e2cd77976e1/crm_ui/static/js/hooks/useDebounce.js
 *
 * Hook to debounce a rapidly changing value in a functional component
 *
 * @example
 * function MyUISelect({search}) {
 *   const [results, setResults] = useState(null);
 *   const debouncedSearch = useDebounce(search, 350);
 *
 *   useEffect(() => {
 *     searchForData(debouncedSearch).then(setResults);
 *   }, [debouncedSearch, setResults]);
 *
 *   return <UISelect {...searchProps} />
 * }
 *
 * @param {<T>any} value The rapidly changing value to debounce
 * @param {Number} delayMs The delay between state changes
 * @return {T} The debounced value
 */
export function useDebounce(value, delayMs = 250) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(handler);
  }, [delayMs, value]);
  return debouncedValue;
}